import React, { useState } from 'react';
import axios from 'axios';

// Kelola Google Cloud project dari dashboard — 2026-10-09
const empty = { project_id: '', project_name: '', client_id_oauth: '', client_secret: '', quota_limit: '10000' };
const card = { background: 'rgba(255,255,255,0.055)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, padding: 18, marginBottom: 16 };
const input = { width: '100%', padding: '9px 11px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(255,255,255,0.05)', color: '#f1f5f9', fontSize: 13, marginBottom: 8, boxSizing: 'border-box' };
const btn = (c) => ({ padding: '7px 12px', borderRadius: 8, border: `1px solid ${c}`, background: 'transparent', color: c, fontSize: 12, fontWeight: 600, cursor: 'pointer', marginRight: 6, marginTop: 6 });
const errMsg = (e) => e.response?.data?.error || 'Error';

function Field({ obj, setObj, k, label, ...extra }) {
  return <input style={input} placeholder={label} value={obj[k]} onChange={e => setObj({ ...obj, [k]: e.target.value })} {...extra} />;
}

export function AddGoogleProject({ api, onChanged, showMsg }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${api}/api/admin/google-projects`, form);
      showMsg(`✅ Project ${r.data.project_id} ditambahkan`);
      setForm(empty); setOpen(false); onChanged();
    } catch (e) { showMsg(errMsg(e), 'error'); }
    setBusy(false);
  };
  if (!open) {
    return <div style={{ marginBottom: 16 }}><button style={btn('#3b82f6')} onClick={() => setOpen(true)}>+ Tambah Google Project</button></div>;
  }
  return (
    <div style={card}>
      <div style={{ fontWeight: 600, fontSize: 14, color: '#f1f5f9', marginBottom: 10 }}>Tambah Google Project</div>
      <Field obj={form} setObj={setForm} k="project_id" label="Project ID (contoh: starhub-creative-02)" />
      <Field obj={form} setObj={setForm} k="project_name" label="Nama tampilan (opsional)" />
      <Field obj={form} setObj={setForm} k="client_id_oauth" label="Client ID (...apps.googleusercontent.com)" />
      <Field obj={form} setObj={setForm} k="client_secret" label="Client Secret" type="password" autoComplete="new-password" />
      <Field obj={form} setObj={setForm} k="quota_limit" label="Quota limit" type="number" min="100" />
      <div style={{ fontSize: 11, color: '#64748b', marginBottom: 4 }}>Pastikan redirect URI di OAuth client project ini sama dengan project lama.</div>
      <button style={btn('#10b981')} disabled={busy} onClick={save}>{busy ? 'Menyimpan...' : 'Simpan'}</button>
      <button style={btn('#64748b')} onClick={() => { setOpen(false); setForm(empty); }}>Batal</button>
    </div>
  );
}

export function GoogleProjectActions({ api, project: p, onChanged, showMsg }) {
  const [editing, setEditing] = useState(false);
  const [edit, setEdit] = useState({});
  const [busy, setBusy] = useState('');
  const [test, setTest] = useState(null);
  const run = async (key, fn) => {
    setBusy(key);
    try { await fn(); } catch (e) { showMsg(errMsg(e), 'error'); }
    setBusy('');
  };
  const doTest = () => run('test', async () => {
    try {
      const r = await axios.post(`${api}/api/admin/google-projects/${p.id}/test`);
      setTest(r.data);
    } catch (e) { setTest({ ok: false, detail: errMsg(e) }); }
  });
  const startEdit = () => {
    setEdit({ project_name: p.project_name || '', client_id_oauth: p.client_id_oauth || '', client_secret: '', quota_limit: String(p.quota_limit) });
    setEditing(true);
  };
  const save = () => run('save', async () => {
    await axios.patch(`${api}/api/admin/google-projects/${p.id}`, edit);
    showMsg('✅ Perubahan disimpan'); setEditing(false); onChanged();
  });
  const toggle = () => {
    if (p.is_active) {
      const n = parseInt(p.user_count, 10) || 0;
      if (!window.confirm(`Nonaktifkan ${p.project_id}?\n\n${n} akun Google terhubung ke project ini. Semua channel mereka BERHENTI upload sampai project diaktifkan lagi.`)) return;
    }
    run('toggle', async () => {
      await axios.patch(`${api}/api/admin/google-projects/${p.id}`, { is_active: !p.is_active });
      showMsg(p.is_active ? '⏸️ Project dinonaktifkan' : '▶️ Project diaktifkan'); onChanged();
    });
  };
  return (
    <div style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid rgba(255,255,255,0.08)' }}>
      <div style={{ fontSize: 11, color: '#64748b' }}>{p.client_secret_hint ? `Secret ${p.client_secret_hint}` : '⚠️ Secret belum diisi'}</div>
      {test && <div style={{ fontSize: 12, color: test.ok ? '#10b981' : '#ef4444', marginTop: 6 }}>{test.ok ? '✅' : '❌'} {test.detail}</div>}
      {editing ? (
        <div style={{ marginTop: 10 }}>
          <Field obj={edit} setObj={setEdit} k="project_name" label="Nama tampilan" />
          <Field obj={edit} setObj={setEdit} k="client_id_oauth" label="Client ID" />
          <Field obj={edit} setObj={setEdit} k="client_secret" label="Client Secret baru (kosongkan jika tidak diubah)" type="password" autoComplete="new-password" />
          <Field obj={edit} setObj={setEdit} k="quota_limit" label="Quota limit" type="number" min="100" />
          <button style={btn('#10b981')} disabled={busy === 'save'} onClick={save}>{busy === 'save' ? 'Menyimpan...' : 'Simpan'}</button>
          <button style={btn('#64748b')} onClick={() => setEditing(false)}>Batal</button>
        </div>
      ) : (
        <div>
          <button style={btn('#06b6d4')} disabled={busy === 'test'} onClick={doTest}>{busy === 'test' ? 'Mengetes...' : 'Tes Koneksi'}</button>
          <button style={btn('#94a3b8')} onClick={startEdit}>Edit</button>
          <button style={btn(p.is_active ? '#ef4444' : '#10b981')} disabled={busy === 'toggle'} onClick={toggle}>{p.is_active ? 'Nonaktifkan' : 'Aktifkan'}</button>
        </div>
      )}
    </div>
  );
}
